export enum BuildingFloorsEnum {
  "平屋" = "平屋",
  "２階建" = "２階建",
  "３階建" = "３階建",
  "４階建" = "４階建"
}
